import { render, staticRenderFns } from "./wewenang.vue?vue&type=template&id=1d816b18&"
import script from "./wewenang.vue?vue&type=script&lang=js&"
export * from "./wewenang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports